import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { AuthService } from '@services/auth/auth.service';
import { SignoAuditoriaPayload } from '@interfaces/interface-bakend/auditoria/signo-auditoria.interface';
import { SignoAuditoriaEvento, SignoAuditoriaFiltros } from '@interfaces/interface-bakend/auditoria/signo-auditoria-evento.interface';

const URL_BACKEND = environment.urlBackend;

@Injectable({ providedIn: 'root' })
export class SignoAuditoriaService {

    moduloSeleccionado: string;
    eventoSeleccionado: SignoAuditoriaEvento;
    accesoDenegado = false;

    private readonly EMAILS_AUDITORIA: string[] = [
        'daniloklimczuk@uoetsylra.org',
        'soporte1@uoetsylra.org',
        'prensa@uoetsylra.org',
        'ramossistemas@gmail.com',
        'm.adrian.torres@gmail.com',
        'naumannthostrupivan@gmail.com',
    ];

    constructor(
        private httpClient: HttpClient,
        private authService: AuthService,
    ) {}

    async puedeAccederAuditoria(): Promise<boolean> {
        const user = await this.authService.getUserLogon();
        const email = (user?.email || '').trim().toLowerCase();
        return this.EMAILS_AUDITORIA.includes(email);
    }

    setAccesoDenegado(valor: boolean): void {
        this.accesoDenegado = valor;
    }

    async registrarEvento(data: SignoAuditoriaPayload): Promise<void> {
        try {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            console.log('[Auditoria] Enviando payload:', data);

            this.httpClient
                .post(`${URL_BACKEND}/signo-auditoria`, data, { headers })
                .subscribe(
                    (resp) => console.log('[Auditoria] Respuesta:', resp),
                    (error) => console.error('[Auditoria] Error:', error),
                );
        } catch (error) {
            console.error('[Auditoria] Error al preparar evento:', error);
        }
    }

    /**
     * Lectura de eventos de auditoría (pantalla de administración).
     * GET /signo-auditoria con filtros por query params (x-token).
     */
    getEventos(filtros?: SignoAuditoriaFiltros): Promise<SignoAuditoriaEvento[]> {
        return new Promise(async (resolve) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            let params = new HttpParams();
            if (filtros) {
                Object.keys(filtros).forEach((key) => {
                    const valor = (filtros as any)[key];
                    if (valor !== undefined && valor !== null && valor !== '') {
                        params = params.set(key, `${valor}`);
                    }
                });
            }

            console.log('[Auditoria][GET] params:', filtros);

            this.httpClient
                .get<any>(`${URL_BACKEND}/signo-auditoria`, { headers, params })
                .subscribe(
                    (resp: any) => {
                        console.log('[Auditoria][GET] respuesta cruda:', resp);
                        const data = resp?.data ?? resp?.docs ?? resp?.results ?? resp;
                        resolve(Array.isArray(data) ? data : []);
                    },
                    (error) => {
                        console.error('[Auditoria][GET] Error:', error);
                        resolve([]);
                    },
                );
        });
    }

    /**
     * Eventos de un módulo/componente puntual (ej. 'Coseguros', 'Planes').
     */
    async getEventosByModulo(modulo: string): Promise<SignoAuditoriaEvento[]> {
        return this.getEventos({ modulo });
    }

    /**
     * Un evento por id (vista detalle). Reutiliza el listado por ahora.
     */
    async getEventoById(id: string): Promise<SignoAuditoriaEvento | undefined> {
        const eventos = await this.getEventos();
        return eventos.find((e) => e._id === id);
    }

    setModuloSeleccionado(modulo: string): void {
        this.moduloSeleccionado = modulo;
    }

    getModuloSeleccionado(): string {
        return this.moduloSeleccionado;
    }

    setEventoSeleccionado(evento: SignoAuditoriaEvento): void {
        this.eventoSeleccionado = evento;
    }

    getEventoSeleccionado(): SignoAuditoriaEvento {
        return this.eventoSeleccionado;
    }

    exportarEventos(filtros: SignoAuditoriaFiltros): Promise<Blob> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            let params = new HttpParams();
            Object.keys(filtros).forEach((key) => {
                const valor = (filtros as any)[key];
                if (valor !== undefined && valor !== null && valor !== '') {
                    params = params.set(key, `${valor}`);
                }
            });

            this.httpClient
                .get(`${URL_BACKEND}/signo-auditoria/exportar`, {
                    headers,
                    params,
                    responseType: 'blob',
                })
                .subscribe(
                    (blob) => resolve(blob),
                    (error) => {
                        console.error('[Auditoria][EXPORT] Error:', error);
                        reject(error);
                    },
                );
        });
    }
}
